import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const UnlinkConfirmation = (props) => {

    return (
        <Dialog open={props.show} onClose={props.onClose}>
            <DialogContent sx={{ m: "20px 0", overflow: 'hidden' }}>
                <Typography>Are you sure you want to unlink this task</Typography>
            </DialogContent>
            <DialogActions sx={{ justifyContent: "space-around", borderTop: "none", pt: 0, pb: 2 }}>
                <Button style={{width: 75}} variant="contained" onClick={() => {props.onUnlink();props.onClose()}}>Yes</Button>
                <Button style={{width: 75}} variant="outlined" onClick={props.onClose}>No</Button>
            </DialogActions>
        </Dialog>
    )
}

export default UnlinkConfirmation